module.exports = __webpack_public_path__ + "static/media/6410_Conti_360_Logo_RGB_Black.ed152c2a.png";